// app/javascript/stream_retry.js

document.addEventListener('turbo:load', function() {
  initializeStreamRetry()
})

if (!window.Turbo) {
  document.addEventListener('DOMContentLoaded', function() {
    initializeStreamRetry()
  })
}

function initializeStreamRetry() {
  const container = document.querySelector('#stream-container')
  const player = document.querySelector('#live-player')
  const overlay = document.querySelector('#countdown-overlay')
  const countdownNumber = document.querySelector('#countdown-number')
  const countdownText = document.querySelector('#countdown-text')
  
  if (!player || !overlay || !container) return
  
  const streamUrl = container.dataset.streamUrl
  
  if (!streamUrl) {
    console.error('No stream URL provided in data-stream-url attribute')
    return
  }
  
  console.log('Stream URL loaded from data attribute:', streamUrl)
  
  let countdownTimer = null
  let hlsInstance = null
  
  // Listen for HLS.js instance
  player.addEventListener('hls-instance', (e) => {
    hlsInstance = e.detail
    console.log('🔧 HLS.js instance received:', hlsInstance)
    
    // Listen to actual HLS.js events for retries
    hlsInstance.on('hlsError', (event, data) => {
      console.log('HLS.js Error Event:', data)
      
      if (data.type === 'networkError' && data.details === 'manifestLoadError') {
        if (data.fatal) {
          console.log('❌ Fatal manifest load error - showing countdown')
          startCountdown()
        } else {
          console.log('⚠️ Non-fatal manifest load error - HLS.js will retry')
          showOverlay() // Show overlay during retries
        }
      }
    })
    
    // Listen for successful events
    hlsInstance.on('hlsManifestParsed', () => {
      console.log('✅ Manifest parsed successfully')
      onStreamSuccess()
    })
    
    hlsInstance.on('hlsLevelLoaded', () => {
      console.log('✅ Level loaded successfully') 
      onStreamSuccess()
    })
  })
  
  // Also listen to Vidstack events as backup
  player.addEventListener('can-play', onStreamSuccess)
  player.addEventListener('playing', onStreamSuccess)
  
  // Start loading immediately
  player.src = streamUrl
  
  function startCountdown() {
    console.log('Starting countdown due to fatal error...')
    showOverlay()
    
    let timeLeft = 15
    updateCountdownDisplay(timeLeft)
    
    countdownTimer = setInterval(() => {
      timeLeft--
      updateCountdownDisplay(timeLeft)
      
      if (timeLeft <= 0) {
        clearInterval(countdownTimer)
        hideOverlay()
        console.log('Retrying stream after countdown...')
        player.src = streamUrl + '?t=' + Date.now()
      }
    }, 1000)
  }
  
  function onStreamSuccess() {
    console.log('🎉 Stream loaded successfully!')
    
    if (countdownTimer) clearInterval(countdownTimer)
    hideOverlay()
    
    player.play().catch(e => {
      console.log('Autoplay blocked:', e.message)
    })
  }
  
  function showOverlay() {
    overlay.style.display = 'flex'
  }
  
  function hideOverlay() {
    overlay.style.display = 'none'
  }
  
  function updateCountdownDisplay(seconds) {
    countdownNumber.textContent = seconds
    countdownText.textContent = seconds
  }
}